import {
  GET_QUOTE_LIST,
  GET_QUOTE_LIST_SUCCESS,
  GET_QUOTE_LIST_FAILURE,
  GET_QUOTE_DETAILS,
  GET_QUOTE_DETAILS_SUCCESS,
  GET_QUOTE_DETAILS_FAILURE,
  CREATE_QUOTE,
  CREATE_QUOTE_SUCCESS,
  CREATE_QUOTE_FAILURE,
  UPDATE_QUOTE,
  UPDATE_QUOTE_SUCCESS,
  UPDATE_QUOTE_FAILURE,
  DELETE_QUOTE,
  DELETE_QUOTE_SUCCESS,
  DELETE_QUOTE_FAILURE,
  GET_QUOTE_STATUS_LIST,
  GET_QUOTE_STATUS_LIST_SUCCESS,
  GET_QUOTE_STATUS_LIST_FAILURE,
  GET_QUOTE_PDF,
  GET_QUOTE_PDF_SUCCESS,
  GET_QUOTE_PDF_FAILURE,
  ADD_NEW_QUOTE_STATUS,
  ADD_NEW_QUOTE_STATUS_SUCCESS,
  ADD_NEW_QUOTE_STATUS_FAILURE,
  UPDATE_QUOTE_STATUS,
  UPDATE_QUOTE_STATUS_SUCCESS,
  UPDATE_QUOTE_STATUS_FAILURE,
  DELETE_QUOTE_STATUS,
  DELETE_QUOTE_STATUS_SUCCESS,
  DELETE_QUOTE_STATUS_FAILURE,
  GET_SINGLE_CUSTOMER_QUOTE_LIST,
  GET_SINGLE_CUSTOMER_QUOTE_LIST_SUCCESS,
  GET_SINGLE_CUSTOMER_QUOTE_LIST_FAILURE,
} from "./actionType";

// Reducer for Quote

const initialState = {
  quoteList: [],
  quoteDetails: {},
  quoteStatusList: [],
  loading: false,
  error: null,
  createSuccess: [],
  updateSuccess: [],
  deleteSuccess: [],
  singleQuotePdf: [],
  getQuotesListLoading: false,
  addQuoteStatusSuccess: [],
  updateQuoteStatusSuccess: [],
  deleteQuoteStatusSuccess: [],
  singleCustomerSearchList: [],

  SingleCustomerQuoteList: [],
  singleCustomerQuoteListLoading: false,
};

export default function Quote(state = initialState, action) {
  switch (action.type) {
    case GET_QUOTE_LIST:
      return {
        ...state,
        getQuotesListLoading: true,
      };
    case GET_QUOTE_LIST_SUCCESS:
      return {
        ...state,
        getQuotesListLoading: false,
        quoteList: action.payload,
      };
    case GET_QUOTE_LIST_FAILURE:
      return {
        ...state,
        getQuotesListLoading: false,
        error: action.payload,
      };
    case GET_QUOTE_DETAILS:
      return {
        ...state,
        loading: true,
      };
    case GET_QUOTE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        quoteDetails: action.payload,
      };
    case GET_QUOTE_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CREATE_QUOTE:
      return {
        ...state,
        loading: true,
      };
    case CREATE_QUOTE_SUCCESS:
      return {
        ...state,
        loading: false,
        createSuccess: action.payload,
      };
    case CREATE_QUOTE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_QUOTE:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_QUOTE_SUCCESS:
      return {
        ...state,
        loading: false,
        updateSuccess: action.payload,
      };
    case UPDATE_QUOTE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DELETE_QUOTE:
      return {
        ...state,
        loading: true,
      };
    case DELETE_QUOTE_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteSuccess: action.payload,
      };
    case DELETE_QUOTE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_QUOTE_STATUS_LIST:
      return {
        ...state,
        loading: true,
      };
    case GET_QUOTE_STATUS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        quoteStatusList: action.payload,
      };
    case GET_QUOTE_STATUS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_QUOTE_PDF:
      return {
        ...state,
        loading: true,
      };
    case GET_QUOTE_PDF_SUCCESS:
      return {
        ...state,
        singleQuotePdf: action.payload,
        loading: false,
      };
    case GET_QUOTE_PDF_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case ADD_NEW_QUOTE_STATUS:
      return {
        ...state,
      };
    case ADD_NEW_QUOTE_STATUS_SUCCESS:
      return {
        ...state,
        addQuoteStatusSuccess: action.payload,
      };
    case ADD_NEW_QUOTE_STATUS_FAILURE:
      return {
        ...state,
        addQuoteStatusSuccess: action.payload,
      };
    case UPDATE_QUOTE_STATUS:
      return {
        ...state,
      };
    case UPDATE_QUOTE_STATUS_SUCCESS:
      return {
        ...state,
        updateQuoteStatusSuccess: action.payload,
      };
    case UPDATE_QUOTE_STATUS_FAILURE:
      return {
        ...state,
        updateQuoteStatusSuccess: action.payload,
      };
    case DELETE_QUOTE_STATUS:
      return {
        ...state,
      };
    case DELETE_QUOTE_STATUS_SUCCESS:
      return {
        ...state,
        deleteQuoteStatusSuccess: action.payload,
      };
    case DELETE_QUOTE_STATUS_FAILURE:
      return {
        ...state,
        deleteQuoteStatusSuccess: action.payload,
      };
    case GET_SINGLE_CUSTOMER_QUOTE_LIST:
      return {
        ...state,
        singleCustomerQuoteListLoading: true,
      };
    case GET_SINGLE_CUSTOMER_QUOTE_LIST_SUCCESS:
      return {
        ...state,
        singleCustomerQuoteListLoading: false,
        SingleCustomerQuoteList: action.payload,
      };
    case GET_SINGLE_CUSTOMER_QUOTE_LIST_FAILURE:
      return {
        ...state,
        singleCustomerQuoteListLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
